export interface RequestState<T> {
	loadingMessage?: string;
	data?: T;
	isLoading: boolean;
	error: boolean;
	errorMessage?: string;
	errorCode?: string;
}

export function success<T>(data: T): RequestState<T> {
	return {
		data,
		isLoading: false,
		error: false,
		errorMessage: undefined,
		loadingMessage: undefined,
		errorCode: undefined,
	};
}

export function load<T>(message: string | undefined, oldData?: T): RequestState<T> {
	return {
		data: oldData,
		isLoading: true,
		error: false,
		errorMessage: undefined,
		errorCode: undefined,
		loadingMessage: message,
	};
}

export function error<T>(message: string, oldData?: T): RequestState<T> {
	return {
		data: oldData,
		isLoading: false,
		error: true,
		errorMessage: message,
		errorCode: undefined,
		loadingMessage: undefined,
	};
}

export function empty<T>(): RequestState<T> {
	return {
		data: undefined,
		isLoading: false,
		error: false,
		errorMessage: undefined,
		errorCode: undefined,
		loadingMessage: undefined,
	};
}
